import { imageRoutesDefinitions } from '@/routes-definitions';

export const imageRoutes = [
  {
    path: imageRoutesDefinitions.home.path,
    name: imageRoutesDefinitions.home.name,
    component: () => import('./pages/HomeView.vue')
  },
  {
    path: imageRoutesDefinitions.images.path,
    name: imageRoutesDefinitions.images.name,
    component: () => import('./pages/ImageView.vue')
  },
  {
    path: imageRoutesDefinitions.results.path,
    name: imageRoutesDefinitions.results.name,
    component: () => import('./pages/SearchResultView.vue')
  }
];
